var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 298.534,
    height: 57.248,
    viewBox: "0 0 298.534 57.248",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 298.534,
    height: 57.248,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.15,35.121a13.945,13.945,0,0,1,7.533,2.02q5.3,3.367,5.3,10.605a12.067,12.067,0,0,1-3.619,9.09,12.9,12.9,0,0,1-9.343,3.535H136.409V59.277h3.367V36.215h-3.367V35.121ZM143.4,36.215V59.277h4.755a10.54,10.54,0,0,0,1.642-.126q7.154-1.094,7.154-11.573a19.632,19.632,0,0,0-.631-5.3q-1.641-6.06-8.291-6.06Z",
    transform: "translate(-86.591 -22.295)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.3,36.452q4.839,3.62,4.84,10.563a12.665,12.665,0,0,1-4,9.679,12.031,12.031,0,0,1-8.543,3.367,12.275,12.275,0,0,1-7.828-2.693q-4.671-3.7-4.671-10.521a12.426,12.426,0,0,1,12.626-12.878,12.216,12.216,0,0,1,7.575,2.483m-4.461,21.8q5.091-2.23,5.092-11.405-.042-11.615-8.333-11.7a9.524,9.524,0,0,0-2.23.253q-6.06,1.6-6.06,11.615a21.744,21.744,0,0,0,.589,5.345q1.725,6.524,7.828,6.523a7.634,7.634,0,0,0,3.114-.631",
    transform: "translate(-140.353 -21.563)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.556,60.372a1.4,1.4,0,0,1-.631-.126q-.463-.253-1.22-2.4l-4.5-12.71L312.73,60.582h-.337a1.6,1.6,0,0,1-.505-.084q-.674-.253-1.515-2.651L302.63,36.215h-2.483V35.121h9.259v1.094H306L313.109,56,317.528,43.2l-2.862-8.08H321.9v1.094H318.5l6.776,19.864,6.607-19.864h-3.367V35.121h6.818v1.094h-2.1l-8.333,24.157Z",
    transform: "translate(-190.531 -22.295)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.772,35.121H430.4v1.094h-3.367V60.161l-1.936.421-16.54-20.79V59.278h2.483a2.2,2.2,0,0,1,.421.042q.672.126.673,1.052h-8.627V59.278h3.367V36.215h-3.367V35.121h5.85l15.992,19.948V36.215h-3.577Z",
    transform: "translate(-256.143 -22.295)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.937,60.372V59.278h4V36.215h-2.272q-3.241.253-4.587,4.377l-.673,2.82h-1.178l.21-8.291h20.79l.21,8.291h-1.179l-.673-2.82a.578.578,0,0,1-.042-.253Q506.4,36.216,503,36.215h-2.441V59.278h2.862a2.2,2.2,0,0,1,.421.042q.672.127.673,1.052Z",
    transform: "translate(-309.921 -22.295)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.593,36.452q4.839,3.62,4.84,10.563a12.665,12.665,0,0,1-4,9.679,12.032,12.032,0,0,1-8.543,3.367,12.275,12.275,0,0,1-7.828-2.693q-4.671-3.7-4.671-10.521a12.426,12.426,0,0,1,12.626-12.878,12.216,12.216,0,0,1,7.575,2.483m-4.461,21.8q5.091-2.23,5.092-11.405-.042-11.615-8.333-11.7a9.523,9.523,0,0,0-2.23.253Q565.6,37,565.6,47.015a21.746,21.746,0,0,0,.589,5.345q1.725,6.524,7.828,6.523a7.633,7.633,0,0,0,3.114-.631",
    transform: "translate(-356.367 -21.563)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.848,60.372a1.4,1.4,0,0,1-.631-.126q-.463-.253-1.22-2.4l-4.5-12.71-5.471,15.445h-.337a1.6,1.6,0,0,1-.505-.084q-.673-.253-1.515-2.651l-7.743-21.632h-2.483V35.121H649.7v1.094h-3.409L653.4,56,657.82,43.2l-2.862-8.08H662.2v1.094h-3.409l6.776,19.864,6.607-19.864H668.8V35.121h6.818v1.094h-2.1l-8.333,24.157Z",
    transform: "translate(-406.546 -22.295)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.064,35.121h8.627v1.094h-3.367V60.161l-1.936.421-16.539-20.79V59.278h2.483a2.2,2.2,0,0,1,.421.042q.673.126.673,1.052H743.8V59.278h3.367V36.215H743.8V35.121h5.85l15.992,19.948V36.215h-3.577Z",
    transform: "translate(-472.158 -22.295)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.992,0,74.73,52.893,48.415,26.2Z",
    transform: "translate(-30.734 0)",
    fill: "#76777a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.168,43.545l-8.59,8.727L1.028,28.721,25.619,3.636l8,8.959.545-.486L25.644,2.567,0,28.726,24.582,53.308l.516-.516,0,0,8.594-8.731Z",
    transform: "translate(0 -1.629)",
    fill: "#e5e6ea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.472,140.735V131.62h.655v8.524h5.443v.591Z",
    transform: "translate(-211.05 -83.551)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.087,140.8a3.885,3.885,0,0,1-1.823-.385,3.1,3.1,0,0,1-1.168-1.046,4.54,4.54,0,0,1-.629-1.482,7.34,7.34,0,0,1-.192-1.682V131.62h.655V136.2a6.972,6.972,0,0,0,.154,1.464,4.048,4.048,0,0,0,.507,1.29,2.543,2.543,0,0,0,.963.9,3.135,3.135,0,0,0,1.521.334,3.071,3.071,0,0,0,1.534-.347,2.646,2.646,0,0,0,.963-.917,3.949,3.949,0,0,0,.5-1.284,7.112,7.112,0,0,0,.148-1.444V131.62h.655V136.2a7.428,7.428,0,0,1-.2,1.74,4.283,4.283,0,0,1-.648,1.47,3.191,3.191,0,0,1-1.168,1.014,3.82,3.82,0,0,1-1.772.373",
    transform: "translate(-227.43 -83.551)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.014,131.62l3.184,4.133,3.171-4.133h.757l-3.569,4.621,3.466,4.494h-.757l-3.068-4.006-3.081,4.006h-.77l3.466-4.494-3.569-4.621Z",
    transform: "translate(-247.089 -83.551)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.8,140.8a3.885,3.885,0,0,1-1.823-.385,3.1,3.1,0,0,1-1.168-1.046,4.54,4.54,0,0,1-.629-1.482,7.34,7.34,0,0,1-.192-1.682V131.62h.655V136.2a6.976,6.976,0,0,0,.154,1.464,4.05,4.05,0,0,0,.507,1.29,2.543,2.543,0,0,0,.963.9,3.135,3.135,0,0,0,1.521.334,3.07,3.07,0,0,0,1.534-.347,2.65,2.65,0,0,0,.963-.917,3.957,3.957,0,0,0,.5-1.284,7.116,7.116,0,0,0,.148-1.444V131.62h.655V136.2a7.426,7.426,0,0,1-.2,1.74,4.284,4.284,0,0,1-.648,1.47,3.193,3.193,0,0,1-1.168,1.014,3.821,3.821,0,0,1-1.772.373",
    transform: "translate(-267.239 -83.551)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.978,140.735V131.62h3.787a2.341,2.341,0,0,1,1.072.244,2.748,2.748,0,0,1,.834.648,3.14,3.14,0,0,1,.552.9,2.76,2.76,0,0,1,.2,1.027,3.021,3.021,0,0,1-.27,1.271,2.728,2.728,0,0,1-.751.989,2.207,2.207,0,0,1-1.124.488l2.273,3.543h-.758l-2.208-3.441h-2.952v3.441Zm.655-4.044h3.2a1.687,1.687,0,0,0,1.027-.321,2.112,2.112,0,0,0,.674-.834,2.562,2.562,0,0,0,.238-1.091,2.26,2.26,0,0,0-.276-1.1,2.342,2.342,0,0,0-.732-.822,1.76,1.76,0,0,0-1.021-.315h-3.106Z",
    transform: "translate(-288.816 -83.551)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.99,131.62l3.184,5.045,3.2-5.045h.732l-3.595,5.674v3.441h-.654v-3.466l-3.582-5.649Z",
    transform: "translate(-305.507 -83.551)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.481,140.735V131.62h3.787a2.34,2.34,0,0,1,1.072.244,2.748,2.748,0,0,1,.835.648,3.141,3.141,0,0,1,.552.9,2.768,2.768,0,0,1,.2,1.027,3.021,3.021,0,0,1-.27,1.271,2.733,2.733,0,0,1-.751.989,2.207,2.207,0,0,1-1.124.488l2.272,3.543H534.3l-2.208-3.441h-2.953v3.441Zm.655-4.044h3.2a1.685,1.685,0,0,0,1.027-.321,2.119,2.119,0,0,0,.674-.834,2.567,2.567,0,0,0,.238-1.091,2.26,2.26,0,0,0-.276-1.1,2.346,2.346,0,0,0-.732-.822,1.759,1.759,0,0,0-1.021-.315h-3.107Z",
    transform: "translate(-335.476 -83.551)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.4,140.144v.591h-6.072V131.62h5.957v.59h-5.3v3.582h4.634v.565h-4.634v3.787Z",
    transform: "translate(-354.421 -83.551)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.97,131.62h.565l3.851,9.115h-.693l-1.242-3h-4.4l-1.248,3h-.706Zm2.258,5.572-1.975-4.776-1.982,4.776Z",
    transform: "translate(-370.778 -83.551)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.627,140.735V131.62h.655v8.524h5.443v.591Z",
    transform: "translate(-392.065 -83.551)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.234,140.144v.591h-6.072V131.62h5.957v.59h-5.3v3.582h4.634v.565h-4.634v3.787Z",
    transform: "translate(-419.066 -83.551)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.432,133.024a2.776,2.776,0,0,0-.488-.43,2.893,2.893,0,0,0-.578-.308,3.51,3.51,0,0,0-.668-.186,4.424,4.424,0,0,0-.77-.064,3.028,3.028,0,0,0-1.945.507,1.682,1.682,0,0,0-.61,1.365,1.41,1.41,0,0,0,.276.917,1.884,1.884,0,0,0,.867.545,12.339,12.339,0,0,0,1.528.4,11.136,11.136,0,0,1,1.708.481,2.62,2.62,0,0,1,1.11.75,1.953,1.953,0,0,1,.391,1.282,2.3,2.3,0,0,1-.231,1.057,1.973,1.973,0,0,1-.668.75,3.3,3.3,0,0,1-1.033.448,5.326,5.326,0,0,1-1.329.154,5.744,5.744,0,0,1-1.348-.154,5.224,5.224,0,0,1-1.207-.449,4.675,4.675,0,0,1-1.052-.757l.347-.526a3.489,3.489,0,0,0,.635.545,4.055,4.055,0,0,0,.77.4,5.15,5.15,0,0,0,.893.263,4.984,4.984,0,0,0,.989.1,3.385,3.385,0,0,0,1.868-.442,1.646,1.646,0,0,0,.366-2.288,2.19,2.19,0,0,0-.95-.609,11.883,11.883,0,0,0-1.6-.442,11.261,11.261,0,0,1-1.637-.462,2.274,2.274,0,0,1-1.014-.692,1.867,1.867,0,0,1-.34-1.18,2.341,2.341,0,0,1,.4-1.391,2.492,2.492,0,0,1,1.136-.866,4.476,4.476,0,0,1,1.682-.294,4.934,4.934,0,0,1,1.1.115,3.571,3.571,0,0,1,.937.353,3.82,3.82,0,0,1,.8.6Z",
    transform: "translate(-435.712 -83.44)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.311,132.211h-3.338v8.525h-.655v-8.525h-3.338v-.59h7.331Z",
    transform: "translate(-453.229 -83.552)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.625,131.62h.565l3.852,9.115h-.693l-1.242-3h-4.4l-1.247,3h-.706Zm2.258,5.572-1.975-4.776-1.982,4.776Z",
    transform: "translate(-469.586 -83.551)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.552,132.211h-3.338v8.525h-.655v-8.525h-3.338v-.59h7.33Z",
    transform: "translate(-487.661 -83.552)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.263,140.144v.591H799.19V131.62h5.957v.59h-5.3v3.582h4.634v.565h-4.634v3.787Z",
    transform: "translate(-507.32 -83.551)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHeader);
export default __webpack_public_path__ + "static/media/logo-header.a55d8cc42d68e8b1fdb03c06349b6abb.svg";
export { ForwardRef as ReactComponent };